'use strict';

var cov_1u9uq6ol7t = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/ClientIntlProvider/lib/ClientIntlProvider.js',
      hash = '5a952243b1db3a6f8c69dee3fcbe6adc11dcd294',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/ClientIntlProvider/lib/ClientIntlProvider.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 29,
          column: 3
        }
      },
      '1': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 28,
          column: 5
        }
      },
      '3': {
        start: {
          line: 7,
          column: 8
        },
        end: {
          line: 7,
          column: 53
        }
      },
      '4': {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 8,
          column: 14
        }
      },
      '5': {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 53
        }
      },
      '6': {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 14
        }
      },
      '7': {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 53
        }
      },
      '8': {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 14
        }
      },
      '9': {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 53
        }
      },
      '10': {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 14
        }
      },
      '11': {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 53
        }
      },
      '12': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 14
        }
      },
      '13': {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 53
        }
      },
      '14': {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 14
        }
      },
      '15': {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 53
        }
      },
      '16': {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 14
        }
      }
    },
    fnMap: {
      '0': {
        name: 'checkIntl',
        decl: {
          start: {
            line: 1,
            column: 15
          },
          end: {
            line: 1,
            column: 24
          }
        },
        loc: {
          start: {
            line: 1,
            column: 33
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }, {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }],
        line: 2
      },
      '1': {
        loc: {
          start: {
            line: 5,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 6,
            column: 6
          },
          end: {
            line: 8,
            column: 14
          }
        }, {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 11,
            column: 14
          }
        }, {
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 14,
            column: 14
          }
        }, {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 17,
            column: 14
          }
        }, {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 20,
            column: 14
          }
        }, {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 23,
            column: 14
          }
        }, {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 16
          }
        }, {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 27,
            column: 14
          }
        }],
        line: 5
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0
    },
    f: {
      '0': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0, 0, 0, 0, 0, 0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var checkIntl = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(locale) {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cov_1u9uq6ol7t.f[0]++;
            cov_1u9uq6ol7t.s[0]++;

            if (window.Intl) {
              _context.next = 56;
              break;
            }

            cov_1u9uq6ol7t.b[0][0]++;
            cov_1u9uq6ol7t.s[1]++;
            _context.next = 7;
            return import('intl');

          case 7:
            cov_1u9uq6ol7t.s[2]++;
            _context.t0 = locale;
            _context.next = _context.t0 === 'de' ? 11 : _context.t0 === 'ca' ? 17 : _context.t0 === 'es' ? 23 : _context.t0 === 'fr' ? 29 : _context.t0 === 'it' ? 35 : _context.t0 === 'pt' ? 41 : _context.t0 === 'en' ? 47 : 48;
            break;

          case 11:
            cov_1u9uq6ol7t.b[1][0]++;
            cov_1u9uq6ol7t.s[3]++;
            _context.next = 15;
            return import('intl/locale-data/jsonp/de.js');

          case 15:
            cov_1u9uq6ol7t.s[4]++;
            return _context.abrupt('break', 54);

          case 17:
            cov_1u9uq6ol7t.b[1][1]++;
            cov_1u9uq6ol7t.s[5]++;
            _context.next = 21;
            return import('intl/locale-data/jsonp/ca.js');

          case 21:
            cov_1u9uq6ol7t.s[6]++;
            return _context.abrupt('break', 54);

          case 23:
            cov_1u9uq6ol7t.b[1][2]++;
            cov_1u9uq6ol7t.s[7]++;
            _context.next = 27;
            return import('intl/locale-data/jsonp/es.js');

          case 27:
            cov_1u9uq6ol7t.s[8]++;
            return _context.abrupt('break', 54);

          case 29:
            cov_1u9uq6ol7t.b[1][3]++;
            cov_1u9uq6ol7t.s[9]++;
            _context.next = 33;
            return import('intl/locale-data/jsonp/fr.js');

          case 33:
            cov_1u9uq6ol7t.s[10]++;
            return _context.abrupt('break', 54);

          case 35:
            cov_1u9uq6ol7t.b[1][4]++;
            cov_1u9uq6ol7t.s[11]++;
            _context.next = 39;
            return import('intl/locale-data/jsonp/it.js');

          case 39:
            cov_1u9uq6ol7t.s[12]++;
            return _context.abrupt('break', 54);

          case 41:
            cov_1u9uq6ol7t.b[1][5]++;
            cov_1u9uq6ol7t.s[13]++;
            _context.next = 45;
            return import('intl/locale-data/jsonp/pt.js');

          case 45:
            cov_1u9uq6ol7t.s[14]++;
            return _context.abrupt('break', 54);

          case 47:
            cov_1u9uq6ol7t.b[1][6]++;

          case 48:
            cov_1u9uq6ol7t.b[1][7]++;
            cov_1u9uq6ol7t.s[15]++;
            _context.next = 52;
            return import('intl/locale-data/jsonp/en.js');

          case 52:
            cov_1u9uq6ol7t.s[16]++;
            return _context.abrupt('break', 54);

          case 54:
            _context.next = 57;
            break;

          case 56:
            cov_1u9uq6ol7t.b[0][1]++;

          case 57:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function checkIntl(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = checkIntl;